import React, { useState } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import FloorInfo from './components/FloorInfo';
import Visualizer from './components/Visualizer';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsOfService, setShowTermsOfService] = useState(false);

  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Gallery />
      <About />
      <Services />
      <FloorInfo />
      <WhyChooseUs />
      <Visualizer />
      <Contact />
      <Footer 
        onPrivacyPolicyClick={() => setShowPrivacyPolicy(true)} 
        onTermsOfServiceClick={() => setShowTermsOfService(true)}
      />
      {showPrivacyPolicy && (
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
      )}
      {showTermsOfService && (
        <TermsOfService onClose={() => setShowTermsOfService(false)} />
      )}
    </div>
  );
}

export default App;
